




















































import Vue from 'vue'
import Component from 'vue-class-component'
import { US_STATES_LIST, ZIP_MASK } from '@/constants'
import { FacilityModule } from '@/store/modules/facility.module'
import { HmoModule } from '@/store/modules/hmo.module'
import { getModule } from 'vuex-module-decorators'
import { IFacility, IHmoDTO } from '@zunta/configurations'
import ModalV2 from '@/components/modals/ModalV2.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import { minLength, required, requiredIf } from 'vuelidate/lib/validators'

@Component({
  props: {
    hmoForEdit: {
      type: Object,
      required: false,
      default: null
    }
  },
  components: {
    MultiSelectV2,
    InputValidator,
    SelectV2,
    InputV2,
    LoaderWrapper,
    ModalV2
  }
})
export default class AddHMOModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  hmoModuleInstance: HmoModule = getModule(HmoModule, this.$store)

  HMO: IHmoDTO = {
    id: 0,
    chainId: this.$store.state.chain.chain.id,
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    isAllFacilities: false,
    facilities: []
  }

  originalHmoIsAllFacilities: boolean = false
  originalFacilitesFromHmo: number[] = []
  isEdit: boolean = false
  HMOName: string | null = null
  clickedAllButton: boolean = true
  selectedFacilities: number[] | string[] = this.isUserAllFacilities ? ['all'] : ['select all facilities available']
  ZIP_MASK: string = ZIP_MASK
  isLoading: boolean = false
  hmoErrors: string[] = []

  validations () {
    return {
      HMO: {
        name: {
          required
        },
        address: {
          required
        },
        city: {
          required
        },
        state: {
          required
        },
        zip: {
          required,
          minLength: minLength(5)
        },
        facilities: {
          required: requiredIf(() => !this.clickedAllButton)
        }
      }
    }
  }

  get isUserAllFacilities () {
    return this.$store.state.user.user.isAllFacilities
  }

  get facilities () {
    return this.$store.state.facility.facilities as IFacility[]
  }

  get usersAccessibleFacilities () {
    return this.$store.state.user.user.facilities
  }

  get usersFacilities () {
    if (this.isUserAllFacilities) {
      return this.facilities
    }
    return this.facilities.filter((facility: IFacility) => this.usersAccessibleFacilities.includes(facility.id))
  }

  get facilityOptions () {
    if (!this.usersFacilities || !this.usersFacilities.length) {
      return []
    }
    const fac = [
      this.isUserAllFacilities
        ? {
          key: 'all',
          value: 'all',
          content: 'All facilities'
        }
        : {
          key: 'select all facilities available',
          value: 'select all facilities available',
          content: 'Select All'
        }
    ]
    const arr = this.usersFacilities.map((facility: IFacility) => {
      return {
        key: facility.id,
        value: facility.id,
        content: facility.name ? facility.name : '',
        $isDisabled: this.clickedAllButton
      }
    })
    return [...fac, ...arr]
  }

  get isEveryUserFacilityWithinHMO () {
    return !this.isUserAllFacilities &&
      this.usersFacilities
        .every((facility: IFacility) => this.HMO.facilities
          .find((hmoId: number) => Number(hmoId) === Number(facility.id)))
  }

  get stateList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      key: stateShortName,
      value: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  async mounted () {
    this.isLoading = true
    await this.facilityModuleInstance.getFacilityList({ isAllFacilities: true })
    if (this.$props.hmoForEdit !== null) {
      this.HMO = {
        ...this.$props.hmoForEdit
      }
      this.isEdit = true
      this.HMOName = this.HMO.name
      this.originalHmoIsAllFacilities = this.HMO.isAllFacilities as boolean
      this.clickedAllButton = this.HMO.isAllFacilities as boolean || this.isEveryUserFacilityWithinHMO
      this.originalFacilitesFromHmo = [...this.HMO.facilities]
      if (!this.clickedAllButton) {
        this.selectedFacilities = [...this.HMO.facilities.map(Number)]
      }
    }
    this.isLoading = false
  }

  checkSelectAll (value: number[] | string[]) {
    const selectedAllFacilities = this.isUserAllFacilities && (value as string[]).includes('all')
    const selectedAllFacilitiesAvailable = !this.isUserAllFacilities &&
      ((value as string[]).includes('select all facilities available') || value.length === this.usersFacilities.length)
    if (selectedAllFacilities) {
      this.selectedFacilities = ['all']
    } else if (selectedAllFacilitiesAvailable) {
      this.selectedFacilities = ['select all facilities available']
    }
    this.clickedAllButton = selectedAllFacilities || selectedAllFacilitiesAvailable
  }

  async addHMO (): Promise<void> {
    this.applyFacilitiesToPayload()
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }
    const method = this.isEdit ? 'editHmo' : 'addHmo'
    const payload = {
      ...this.HMO
    }
    await this.hmoModuleInstance[method](payload)
    this.$emit('editOrAddHmo')
    this.$emit('close')
  }

  applyFacilitiesToPayload () {
    const selectedAllFacilities = this.isUserAllFacilities && (this.selectedFacilities as string[]).includes('all')
    const selectedAllFacilitiesAvailable = (this.selectedFacilities as string[]).includes('select all facilities available')
    if (!selectedAllFacilities) {
      this.getFacilitiesForPayLoad(selectedAllFacilitiesAvailable)
    }
    this.HMO.isAllFacilities = selectedAllFacilities ||
      (selectedAllFacilitiesAvailable && this.facilities.length === this.HMO.facilities.length && this.originalHmoIsAllFacilities)
    if (this.HMO.isAllFacilities) {
      this.HMO.facilities = []
    }
  }

  getFacilitiesForPayLoad (isSelectedAllFacilities: boolean) {
    if (isSelectedAllFacilities) { // take all facilities user has access to
      this.HMO.facilities = this.isEdit
        ? this.combineFacilitiesSelected(
          this.takeAwayFacilitiesNotSelected(this.originalFacilitesFromHmo, this.originalHmoIsAllFacilities),
          this.usersFacilities.map((userFacility: IFacility) => userFacility.id) as number[]
        )
        : this.usersFacilities.map((userFacility: IFacility) => userFacility.id) as number[]
    } else {
      this.HMO.facilities = this.isEdit // take only facilities selected
        ? this.combineFacilitiesSelected(
          this.takeAwayFacilitiesNotSelected(this.originalFacilitesFromHmo, this.originalHmoIsAllFacilities),
          this.selectedFacilities as number[]
        )
        : this.HMO.facilities = [...this.selectedFacilities] as number[]
    }
  }

  takeAwayFacilitiesNotSelected (facilities: number[], isHmoAllFacilities: boolean): number[] {
    if (isHmoAllFacilities) {
      facilities = this.facilities.map((facility: IFacility) => facility.id) as number[]
    }
    const facilitiesExcluded = this.usersFacilities
      .filter((userFacility: IFacility) => !this.HMO.facilities.includes(Number(userFacility.id)))
      .map((userFacility: IFacility) => userFacility.id)
    return facilities.filter((hmoFacilityId: number) => !facilitiesExcluded.includes(Number(hmoFacilityId)))
  }

  combineFacilitiesSelected (facilities: number[], facilitiesToCombine: number[]) {
    return [...new Set([...facilities, ...facilitiesToCombine])]
  }
}
